import device from 'current-device'
/**
 * 判断是否为ipad
 * @returns {Boolean} 判断结果
 */
export const isIpad = () => {
  var ua = window.navigator.userAgent
  var IsIPad = false
  if (/ipad/i.test(ua)) {
    IsIPad = true
  }
  // iPad from IOS13
  var macApp = ua.match(/Macintosh/i) != null
  if (macApp) {
    // need to distinguish between Macbook and iPad
    var canvas = document.createElement('canvas')
    if (canvas != null) {
      var context =
        canvas.getContext('webgl') || canvas.getContext('experimental-webgl')
      if (context) {
        var info = context.getExtension('WEBGL_debug_renderer_info')
        if (info) {
          var renderer = context.getParameter(info.UNMASKED_RENDERER_WEBGL)
          if (renderer.indexOf('Apple') != -1) IsIPad = true
        }
      }
    }
  }
  return IsIPad
}

/**
 * 判断是否为移动端(Mobile)
 * @returns {Boolean} 判断结果
 */
export const isEnvMobile = () => {
  let isEnvMobile = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(navigator.userAgent)
  if (!isEnvMobile && device.ipad()) {
    isEnvMobile = true
  }
  return isEnvMobile
}

/**
 * 获取链接具体参数
 * @param {String} name 参数key
 * @param {String} url 链接
 * @returns 
 */
export const getParamFromUrlHashByKey = (name, url = location.hash) => {
  // eslint-disable-next-line
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [, ""])[1].replace(/\+/g, '%20')) || ''
}

export const m_getUrlKey = (name, url = location.href) => {
  // eslint-disable-next-line
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [, ""])[1].replace(/\+/g, '%20')) || '';
}

export const checkWebpFeature = async (feature, callback) => {
  var kTestImages = {
    lossy: 'UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA',
    lossless: 'UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==',
    alpha:
      'UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==',
    animation:
      'UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA'
  };
  var img = new Image();
  img.onload = function () {
    var result = img.width > 0 && img.height > 0;
    callback(feature, result);
  };
  img.onerror = function () {
    callback(feature, false);
  };
  img.src = 'data:image/webp;base64,' + kTestImages[feature];
  return true;
};

export const isSupportWebp = async () => {  
  if (localStorage.isSupportWebp === 'true') {
    return true
  } else if (localStorage.isSupportWebp === 'false') {
    return false
  } else {
    return new Promise(resolve => {
      checkWebpFeature('lossy', function (feature, isSupported) {
        localStorage.isSupportWebp = isSupported
        resolve(isSupported);
      });
    });
  }
};

export const isIOS = () => {  
  const ua = navigator.userAgent;
  const UA_IOS_REG = /\b(iPad|iPhone|iPod|Mac)\b.*? OS /;
  return UA_IOS_REG.test(ua);
}
